import { render, staticRenderFns } from "./BetOddsSummaryTerminal.vue?vue&type=template&id=babb8150&scoped=true"
import script from "./BetOddsSummaryTerminal.vue?vue&type=script&lang=js"
export * from "./BetOddsSummaryTerminal.vue?vue&type=script&lang=js"
import style0 from "./BetOddsSummaryTerminal.vue?vue&type=style&index=0&id=babb8150&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babb8150",
  null
  
)

export default component.exports